import { forwardRef } from 'react';

import { calculateLastPage, calculateNextRowsLength } from './pagination-load-button.utils';

import Button, { ButtonProps } from '../button/button';

export interface PaginationLoadButtonProps extends Omit<ButtonProps, 'children'> {
  children?: (renderProps: { nextRowsLength: number }) => React.ReactNode | React.ReactNode;
  page: number;
  rowsPerPage: number;
  count: number;
  onChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
}

/**
 * Custom button which can integrates pagination logic - Won't be visable if no page is left
 */
export const PaginationLoadButton = forwardRef<HTMLButtonElement, PaginationLoadButtonProps>((props, ref) => {
  const {
    children,
    page,
    rowsPerPage,
    count,
    progressing,
    onChangePage,
    onClick,
    ref: _buttonRef,
    ...buttonProps
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(event);
    onChangePage(event, page + 1);
  };

  // dont render if no count was found
  if (count === 0) {
    return null;
  }

  const lastPage = calculateLastPage(count, rowsPerPage);

  // dont render if last page was reached (only if last page is defined)
  if (page >= lastPage) {
    return null;
  }

  const nextRowsLength = calculateNextRowsLength(page, count, rowsPerPage, lastPage);

  return (
    <Button ref={ref} onClick={handleClick} progressing={progressing} {...buttonProps}>
      {typeof children === 'function' ? children({ nextRowsLength }) : children}
    </Button>
  );
});

export default PaginationLoadButton;
